import { CapsuleButton } from '@ui/components/CapsuleButton';

import { ParticipantStatus } from '@features/shared/api/typings';

import styles from './TournamentParticipationButton.module.css';

type Props = {
  participantStatus?: ParticipantStatus;
  isBeingPreModerated?: boolean;
  onLeave?: () => void;
  onJoin?: () => void;
  canJoin?: boolean;
  canJoinWithTicket: boolean;
  joinWithTicketLink?: string;
  canLeave?: boolean;
  isPending?: boolean;
  isMatch?: boolean;
};

export function TournamentParticipationButton({
  participantStatus,
  isBeingPreModerated,
  isPending,
  isMatch,
  canJoin,
  canJoinWithTicket,
  joinWithTicketLink,
  canLeave,
  onLeave,
  onJoin,
}: Props) {
  if (participantStatus === 'Banned') {
    return (
      <CapsuleButton size="16m-40" preset="hollow" disabled>
        Доступ запрещен
      </CapsuleButton>
    );
  }

  if (participantStatus === 'Removed') {
    return (
      <CapsuleButton size="16m-40" preset="hollow" disabled>
        Удален из турнира
      </CapsuleButton>
    );
  }

  if (canLeave) {
    return (
      <CapsuleButton size="16m-40" onClick={onLeave} preset="gray" disabled={isPending}>
        Выйти из {isMatch ? 'матча' : 'турнира'}
      </CapsuleButton>
    );
  }

  if (isBeingPreModerated) {
    return (
      <CapsuleButton size="16m-40" preset="hollow" disabled>
        Заявка в обработке
      </CapsuleButton>
    );
  }

  if (canJoin) {
    return (
      <CapsuleButton
        size="16m-40"
        onClick={onJoin}
        preset="call-to-action"
        shadow="weak"
        disabled={isPending}
      >
        Принять участие
      </CapsuleButton>
    );
  }

  if (canJoinWithTicket && joinWithTicketLink) {
    return (
      <CapsuleButton
        size="16m-44"
        preset="call-to-action"
        shadow="weak"
        disabled={isPending}
        onClick={() => {
          window.open(joinWithTicketLink);
        }}
      >
        Принять участие <span className={styles.subscription_subtext}>по подписке</span>
      </CapsuleButton>
    );
  }

  return null;
}
